import config from 'config'

const customerApi = `${config.apiHost}`

export default {
    // 朋友圈互动趋势
    countStat: {
        url: `${customerApi}/oem-profile/api/business_moments/comments/count_by_date`,
        type: 'GET',
    },

    // 朋友圈互动统计列表
    getStatList: {
        url: `${customerApi}/oem-profile/api/business_moments/stat`,
        type: 'GET',
    },

    // 朋友圈发布员工列表
    getPostStatList: {
        url: `${customerApi}/oem-profile/api/business_moments/{id}/publish_users`,
        type: 'GET',
    },

    // 朋友圈互动客户占比
    getCustomerStat: {
        url: `${customerApi}/oem-profile/api/business_moments/comments/customer_stat`,
        type: 'GET',
    },

    // 朋友圈互动排行
    getRankList: {
        url: `${customerApi}/oem-profile/api/business_moments/rank`,
        type: 'GET',
    },

    // 朋友圈通用配置
    getMomentConfig: {
        url: `${customerApi}/oem-profile/api/business_moments/config`,
        type: 'GET',
    },

    // 编辑朋友圈通用配置
    editMomentConfig: {
        url: `${customerApi}/oem-profile/api/business_moments/config`,
        type: 'PUT',
    },

    // 导出
    exportData: {
        url: `${customerApi}/oem-profile/api/business_moments/stat/export`,
        type: 'GET',
    },

    // 朋友圈详情
    getMomentDetail: {
        url: `${customerApi}/oem-profile/api/business_moments/{id}?with_publish_count=1&with_creator_name=1`,
        type: 'GET',
    },

    businessMomentsExport: {
        url: `${customerApi}/oem-profile/api/business_moments/export`,
        type: 'POST',
    },

    task: {
        url: `${customerApi}/oem-profile/api/tasks/{id}`,
        type: 'GET',
    },
}
